const Utility = {
  fetchChildIds: async function(productHandle) {
        try {
            const response = await fetch(`/products/${productHandle}?view=childIds`);
            if (!response.ok) {
              throw new Error('Network response was not ok');
            }
            const variantIds = await response.json();
            return variantIds;
          } catch (error) {
            console.error('Error fetching product data:', error);
            return null;
          }
    },
  
  fetchProductDataAjax: async function(productHandle, productType, childIds) {
        try {
            const response = await fetch(`/products/${productHandle}.js`);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            let productData = await response.json();
    
            if (productType == 'Combined Paddle' && childIds) {    
                try {
                    const payload = await fetch(`https://api.selkirk.com/functions/v1/p1/selkirksport/products/variants?ids=${childIds.childProducts}`);
                    if (!payload.ok) {
                        throw new Error('Network response was not ok');
                    }
    
                    // Fetch all variants from the middle layer
                    const response = await payload.json();
                    const variantData = Array.isArray(response.data) ? response.data : [];
                    
                    // Flatten the variants array to remove any pagination-related chunks
                    const allVariants = variantData.flat(); // This will flatten any nested arrays within `variantData`
    
                    // Assign the flattened variants array to productData
                    productData.variants = allVariants;
    
                    return productData;
                } catch (error) {
                    console.error('Error fetching product data:', error);
                    return null;
                }   
            } else {
                return productData;
            }  
        } catch (error) {
            console.error('Error fetching product data:', error);
            return null;
        }   
    },

    fetchProductImages: async function(productHandle, variantId) {
      try {
          const response = await fetch(`/products/${productHandle}?view=var-images&variant=${variantId}`);
          if (!response.ok) {
              throw new Error('Network response was not ok');
              return null;
          }
          
          const productImages = await response.json();
          return productImages;
      } catch (error) {
          console.error('Error fetching product data:', error);
          return null;
      }
    },
      
    fetchProductDetails: async function(productHandle, variantId) {
      try {
          const response = await fetch(`/products/${productHandle}?view=data&variant=${variantId}`);
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          const productData = await response.json();
          return productData;
        } catch (error) {
          console.error('Error fetching product data:', error);
          return null;
        }
    },
    fetchEls: function(selectors, context) {
        Object.entries(selectors).forEach(([key, {selector, type, scope}]) => {
            if (type === 'single') {
                if (scope === 'document') {
                    context[key] = document.querySelector(selector);
                } else {
                    context[key] = context.parent.querySelector(selector);
                }
            } else if (type === 'all') {
                if (scope === 'document') {
                    context[key] = document.querySelectorAll(selector);
                } else {
                    context[key] = context.parent.querySelectorAll(selector);
                }
            }
        });
    },
    shopifyHandleize: function(str) {
      return str
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')  // Replace non-alphanumeric with hyphens
        .replace(/^-+|-+$/g, '');     // Trim leading/trailing hyphens
    },
    formatLocalizedMoney: function(cents, options = {}) {
      if (typeof cents !== 'number') {
        return '';
      }

      const activeCurrency =
        options.currency ||
        window?.Shopify?.currency?.active ||
        document.documentElement.getAttribute('data-currency') ||
        window?.Currency?.currentCurrency ||
        window?.shop_currency ||
        null;

      const locale = options.locale || document.documentElement.lang || undefined;
      const hasCents = options.keepTrailingZeros === true ? true : cents % 100 !== 0;
      const fallbackSymbol = typeof options.fallbackSymbol === 'string' ? options.fallbackSymbol : '$';

      const currencySymbolOverrides = {
        BND: 'B$',
        HKD: 'HK$',
        IDR: 'Rp',
        JPY: '¥',
        KRW: '₩',
        MYR: 'RM',
        PHP: '₱',
        SGD: 'S$',
        THB: '฿',
        TWD: 'NT$',
        VND: '₫',
      };

      const isAsianMarketCurrency = Boolean(activeCurrency && currencySymbolOverrides[activeCurrency]);
      const currencyToFormat = isAsianMarketCurrency ? activeCurrency : 'USD';
      const localeToFormat = isAsianMarketCurrency ? locale : 'en-US';
      const forcedSymbol = isAsianMarketCurrency ? currencySymbolOverrides[activeCurrency] : '$';

      if (activeCurrency) {
        try {
          const formatter = new Intl.NumberFormat(localeToFormat, {
            style: 'currency',
            currency: currencyToFormat,
            currencyDisplay: 'symbol',
            minimumFractionDigits: hasCents ? 2 : 0,
            maximumFractionDigits: hasCents ? 2 : 0,
          });

          if (typeof formatter.formatToParts === 'function') {
            const formatted = formatter
              .formatToParts(cents / 100)
              .map((part) => {
                if (part.type !== 'currency') {
                  return part.value;
                }

                return forcedSymbol;
              })
              .join('');

            return forcedSymbol === 'RM' ? formatted.replace(/^RM[\s\u00A0]+/, 'RM') : formatted;
          }

          const formattedFallback = formatter.format(cents / 100);
          return forcedSymbol === 'RM' ? formattedFallback.replace(/^RM[\s\u00A0]+/, 'RM') : formattedFallback;
        } catch (error) {
          console.warn('Failed to format localized currency, falling back:', error);
        }
      }

      return `${fallbackSymbol}${(cents / 100).toFixed(2).replace(/\.00$/, '')}`;
    },
    smoothScroll: function(element, distance, duration) {
      const startTime = performance.now();
      const startPos = element.scrollLeft;
      const maxScrollLeft = element.scrollWidth - element.clientWidth;
      
      // Ensure target position is within the bounds
      const targetPos = Math.max(0, Math.min(startPos + distance, maxScrollLeft));
    
      function scrollFrame(timestamp) {
        const elapsed = timestamp - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const newPosition = startPos + (targetPos - startPos) * progress;
        element.scrollLeft = newPosition;
    
        if (progress < 1) {
          requestAnimationFrame(scrollFrame);
        }
      }
    
      requestAnimationFrame(scrollFrame);
    },

    renderIframeIn: function(element, videoId) {
        const iframe = document.createElement('iframe');
        iframe.setAttribute('src', 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&mute=1&enablejsapi=1');
        iframe.setAttribute('frameborder', '0');
        iframe.setAttribute('allowfullscreen', '');
        iframe.style.width = '100%';
        iframe.style.height = '100%';
        element.innerHTML = '';
        element.appendChild(iframe);
    },

  openConsentPreferences: function () {
    if (typeof window?.Pandectes?.openDialog === 'function') {
      window.Pandectes.openDialog('preferences');
    }
  },

  getConsentStatus: function (permissionsObject = null) {
    let currentPreferences = permissionsObject;

    if (currentPreferences !== null) {
      return {
        functionality: currentPreferences.preferences === true,
        performance: currentPreferences.analytics === true,
        targeting: currentPreferences.marketing === true
      };
    }

    if (typeof window.Pandectes !== 'undefined') {
      const hasPreferencesMethod = typeof window.Pandectes.preferencesProcessingAllowed === 'function';
      const hasAnalyticsMethod = typeof window.Pandectes.analyticsProcessingAllowed === 'function';
      const hasMarketingMethod = typeof window.Pandectes.marketingAllowed === 'function';

      if (hasPreferencesMethod === true && hasAnalyticsMethod === true && hasMarketingMethod === true) {
        return {
          functionality: window.Pandectes.preferencesProcessingAllowed(),
          performance: window.Pandectes.analyticsProcessingAllowed(),
          targeting: window.Pandectes.marketingAllowed()
        };
      }

      if (typeof window.Pandectes.currentVisitorConsent === 'function') {
        currentPreferences = window.Pandectes.currentVisitorConsent();
        if (currentPreferences !== undefined && currentPreferences !== null) {
          return {
            functionality: currentPreferences.preferences === true,
            performance: currentPreferences.analytics === true,
            targeting: currentPreferences.marketing === true
          };
        }
      }
    }

    // block all optional cookies by default
    return {
      functionality: false,
      performance: false,
      targeting: false
    };
  },

    subscribeCustomerMaestra: async function({
      email,
      source,
      brand = "selkirkcom",
      pointOfContact = "Email",
      endpoint = "https://api.selkirk.com/functions/v1/p1/selkirksport/maestra/backendSubscription",
      formType = null, // required, e.g. "notify", "backInStock"
      productShopifyId = null, // required if formType is "backInStock"
      topic = null, // Required if formType is "notify". E.g. "labs", "AllInWithSelkirk"
      fingerprint = null, // optional
      referralLink = null, // optional
      firstName = null, // optional
      lastName = null, // optional
      phone = null, // optional
      store = null // optional
    }) {
      if (!email) {
        return { ok: false, error: "Email is required" };
      }

      if (!formType) {
        return { ok: false, error: "formType is required" };
      }    
    
      function getCookie(name) {
        const match = document.cookie.match(
          new RegExp(
            "(?:^|; )" +
              name.replace(/([.*+?^${}()|[\\]\\\\])/g, "\\$1") +
              "=([^;]*)"
          )
        );
        return match ? decodeURIComponent(match[1]) : null;
      }
    
      // Default store=asia on the Asia storefront when not explicitly passed
      const shopUrl = window.SelkirkStore?.shopUrl || window.location.hostname || "";
      const isAsiaStore =
        shopUrl.includes("selkirk-asia") || shopUrl.includes("asia.selkirk.com");
      if (!store && isAsiaStore) {
        store = "asia";
      }

      // Build URL with deviceUUID and formType
      const deviceUUID = getCookie("maestraDeviceUUID");
      const queryParams = new URLSearchParams();
      if (deviceUUID) {
        queryParams.set("deviceUUID", deviceUUID);
      }
      queryParams.set("formType", formType);
      if (store) {
        queryParams.set("store", store);
      }
      const url = `${endpoint}?${queryParams.toString()}`;
    
      let payload = null;
      
      // Note: The subscriptions array is only valid in the "notify" form type
      switch (formType) {
        case "backInStock":
          if (!productShopifyId) {
            return { ok: false, error: "productShopifyId is required for backInStock" };
          }
          payload = {
            customer: { email: email },
            addProductToList: {
              product: {
                ids: { shopifyid: String(productShopifyId) }
              }
            }
          };
          break;
    
        case "notify":
          payload = {
            customer: {
              email,
              mobilePhone: phone,
              subscriptions: [
                {
                  brand: brand,
                  pointOfContact: pointOfContact,
                  topic: topic
                }
              ]
            },
            customerAction: {
              customFields: {
                actionSource: source
              }
            }
          };
          break;

        case "referralSignup":
          payload = {
            customer: {
              email,
              firstName,
              lastName,
              mobilePhone: phone,
              customFields: {
                referralLink,
                fingerprint
              }
            }
          };
          break;

        default:
          return { ok: false, error: `Unsupported formType: ${formType}` };
      }
    
      try {
        const resp = await fetch(url, {
          method: "POST",
          headers: { "Content-Type": "application/json", "x-region": "us-west-1" },
          body: JSON.stringify(payload)
        });
    
        let data = null;
        try {
          data = await resp.json();
        } catch (jsonError) {
          console.error("Error parsing response JSON:", jsonError);
        }
    
        const result = {
          ok: resp.ok,
          status: data?.status ?? resp.status,
          statusMessage: data?.statusMessage ?? resp.statusText,
          data: data?.data ?? null,
          raw: data
        };
    
        if (!resp.ok) {
          result.error = "Subscription failed, try again later.";
        }
    
        return result;
      } catch (err) {
        return { ok: false, error: "Subscription failed, try again later." };
      }
    },

  /**
   * Fetch PDP recommendations from Maestra using the OftenBoughtTogether endpoint,
   * which requires a Shopify Variant ID.
   *
   * @param {string|number} variantShopifyId Shopify Variant ID (required)
   * @param {number} [limit=8] Maximum number of recommendations to return
   * @param {string} [baseUrl="https://api.selkirk.com/functions/v1/p1/selkirksport/maestra"] Base API URL
   * @returns {Promise<{ ok: boolean, status: number, statusMessage: string, data: any, raw: any }>}
   */
  getMaestraPdpRecommendations: async function ({
    variantShopifyId,
    limit = 8,
    baseUrl = "https://api.selkirk.com/functions/v1/p1/selkirksport/maestra"
  }) {
    if (!variantShopifyId) {
      return {
        ok: false,
        error: "variantShopifyId is required",
        status: 400,
        statusMessage: "Bad Request",
        data: null,
        raw: null
      };
    }

    const variantIdString = String(variantShopifyId);

    const url = `${baseUrl}/oftenBoughtTogether`;
    const body = {
      recommendation: {
        limit,
        product: {
          ids: {
            shopifyid: variantIdString
          }
        }
      }
    };

    try {
      const resp = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-region": "us-west-1"
        },
        body: JSON.stringify(body)
      });

      let json = null;
      try {
        json = await resp.json();
      } catch (e) {
        console.warn("Failed to parse JSON:", e);
      }

      return {
        ok: resp.ok,
        status: json?.status ?? resp.status,
        statusMessage: json?.statusMessage ?? resp.statusText,
        data: json?.data ?? json ?? null,
        raw: json
      };
    } catch (error) {
      console.error("Error fetching Maestra PDP Recommendations:", error);
      return {
        ok: false,
        status: 0,
        statusMessage: "Network Error",
        error: "Failed to fetch recommendations",
        data: null,
        raw: null
      };
    }
  },

    /**
     * initResponsiveRive: initialize Rive with responsive resize handling.
     * Supports lazy/“in view” loading via IntersectionObserver.
     *
     * Params:
     *  - src: string URL of the .riv asset
     *  - canvasEl: HTMLCanvasElement target
     *  - initialLayout: optional rive.Layout to apply initially
     *  - fillOnResize: boolean, if true switches to Fill layout after load (default: true)
     *  - lazy: optional object to defer load until in view:
     *      { threshold?: number, root?: Element|null, rootMargin?: string }
     *      if provided, waits until intersection before loading.
     *
     * Returns: Promise resolving to the Rive instance (or null if canvasEl missing).
     */
    initResponsiveRive: async function ({
      src,
      canvasEl,
      initialLayout,
      fillOnResize = true,
      lazy = null,
    }) {
      if (!canvasEl) return null;

      // actual instantiation logic
      const createInstance = () =>
        new Promise((resolve) => {
          const riveInstance = new rive.Rive({
            src,
            canvas: canvasEl,
            autoplay: true,
            layout: initialLayout,
            onLoad: () => {
              riveInstance.resizeDrawingSurfaceToCanvas();
              resolve(riveInstance);
            },
          });

          if (fillOnResize) {
            riveInstance.layout = new rive.Layout({ fit: rive.Fit.Fill });
          }

          const resize = () => {
            riveInstance.resizeDrawingSurfaceToCanvas();
          };

          window.addEventListener('resize', resize);
          window
            .matchMedia(`(resolution: ${window.devicePixelRatio}dppx)`)
            .addEventListener('change', resize);
        });

      // If lazy config provided and IntersectionObserver exists, defer until visible
      if (
        lazy &&
        typeof IntersectionObserver !== 'undefined' &&
        canvasEl instanceof Element
      ) {
        return new Promise((resolve) => {
          const observer = new IntersectionObserver(
            (entries, obs) => {
              for (const entry of entries) {
                if (entry.isIntersecting) {
                  obs.unobserve(canvasEl);
                  createInstance().then(resolve);
                  return;
                }
              }
            },
            {
              threshold: lazy.threshold ?? 1,
              root: lazy.root ?? null,
              rootMargin: lazy.rootMargin ?? '0px',
            }
          );
          observer.observe(canvasEl);
        });
      } else {
        // immediate load
        return createInstance();
      }
    },

  initVideoThumbs: function (videoThumbs, innerHTML) {
    videoThumbs.forEach((element) => {
      if (element.dataset.bound === 'true') {
        return;
      }

      element.dataset.bound = 'true';

      if (typeof innerHTML === 'string') {
        element.dataset.videoTemplate = innerHTML;
      }

      element.addEventListener('click', Utility.handleVideoClick);
    });

    if (Utility.pandectesConsentListenerBound !== true) {
      Utility.pandectesConsentListenerBound = true;

      // Handle consent change
      window.addEventListener('PandectesConsentUpdate', (event) => {
        const consentStatus = Utility.getConsentStatus(event.detail);

        // If the user had clicked a video previously, and now consent is granted
        if (consentStatus.functionality === true && Utility.lastClickedVideo !== undefined && Utility.lastClickedVideo !== null) {
          if (Utility.lastClickedVideo.element !== undefined && Utility.lastClickedVideo.videoId !== undefined) {
            const element = Utility.lastClickedVideo.element;
            const videoId = Utility.lastClickedVideo.videoId;
            const template = element.dataset.videoTemplate;

            if (typeof template === 'string') {
              let updatedHTML = template;

              if (updatedHTML.includes('<video_id>')) {
                updatedHTML = updatedHTML.replaceAll('<video_id>', videoId);
              }

              element.innerHTML = updatedHTML;
            }

            Utility.lastClickedVideo = null;
          }
        }
      });
    }
  },

  handleVideoClick: function (event) {
    const element = event.currentTarget;
    const videoId = element.getAttribute('data-video-id');
    const consentStatus = Utility.getConsentStatus();

    if (consentStatus.functionality === true) {
      Utility.renderIframeIn(element, videoId);
    } else {
      Utility.lastClickedVideo = {
        element: element,
        videoId: videoId
      };

      element.innerHTML = `
          <div class="video-consent-message">
            <p>To view this video, please accept functionality cookies.</p>
            <button class="open-consent-btn">Manage Preferences</button>
          </div>
        `;

      const consentButtonElement = element.querySelector('.open-consent-btn');
      if (consentButtonElement !== null) {
        consentButtonElement.addEventListener('click', Utility.openConsentPreferences);
      }
    }
  },

  /**
   * Prevents a popup trigger from firing unless the user has granted targeting cookie consent.
   *
   * On click:
   * • If targeting consent is granted, the event is allowed to proceed and PopMechanic opens the popup.
   * • If not, the click is fully blocked, the button is disabled, and an inline message is shown
   * prompting the user to manage their cookie preferences.
   *
   * Also listens for consent changes: when targeting cookies are later granted, any messages are
   * removed and all previously disabled buttons are re-enabled.
   *
   * @param {object} options
   * @param {string} options.triggerSelector – CSS selector for the popup button(s) to select.
   * @param {string} options.containerSelector – CSS selector for the element to append the warning message into.
   * @param {string} options.messageText – The warning copy to display before the manage-consent link.
   * @param {string} options.linkText – The text for the “Manage cookie preferences” link.
   * @param {Function} options.manageHandler – Callback function that opens the cookie-preferences banner.
   */
  initMaestraPopupConsent: function ({
    triggerSelector,
    containerSelector,
    messageText,
    linkText,
    manageHandler
  }) {
    const triggers = Array.from(document.querySelectorAll(triggerSelector));
    triggers.forEach((element) => {
      if (element.dataset.maestraBound === 'true') {
        return;
      }
      element.dataset.maestraBound = 'true';

      // Capture phase so this runs before PopMechanic’s handler
      element.addEventListener('click', (event) => {
        const consentStatus = Utility.getConsentStatus();
        const targetingOk = consentStatus.targeting;
        if (targetingOk === true) {
          return; // if consent present, allow popup
        }

        // No consent: cancel everything, disable the button, show the message
        event.preventDefault();
        event.stopImmediatePropagation(); // prevents any other click handlers
        element.disabled = true;

        const containerElement = element.closest(containerSelector);
        if (containerElement === null) {
          return;
        }
        containerElement.querySelectorAll('.maestra-popup-message').forEach((node) => {
          node.remove();
        });

        const messageElement = document.createElement('div');
        messageElement.className = 'maestra-popup-message';

        messageElement.append(document.createTextNode(messageText));
        messageElement.append(document.createElement('br'));

        const anchorElement = document.createElement('a');
        anchorElement.className = 'manage-consent';
        anchorElement.textContent = linkText;
        anchorElement.href = '#';
        anchorElement.addEventListener('click', (anchorEvent) => {
          anchorEvent.preventDefault();
          manageHandler();
        });
        messageElement.append(anchorElement);

        containerElement.append(messageElement);
      }, { capture: true });

    });

    // Re-enable buttons and clear messages once targeting consent is granted
    window.addEventListener('PandectesConsentUpdate', (event) => {
      if (Utility.getConsentStatus(event.detail).targeting === true) {
        triggers.forEach((element) => {
          element.disabled = false;
        });
        document.querySelectorAll('.maestra-popup-message').forEach((node) => {
          node.remove();
        });
      }
    });
  },

    hideProgressBarPopup: function () {
      const popup = document.getElementById('progress-bar-popup');
      const reopen = document.getElementById('pb-reopen');
      const OPEN_STATE_KEY = 'pbOpenState';

      if (!popup || !reopen) return;

      // Save the current state before hiding
      let wasOpen = popup.classList.contains('is-open') && popup.getAttribute('aria-hidden') === 'false';
      let wasClosed = !wasOpen && reopen.style.display === 'flex';

      try {
        if (wasOpen) {
          sessionStorage.setItem(OPEN_STATE_KEY, 'open');
        } else if (wasClosed) {
          sessionStorage.setItem(OPEN_STATE_KEY, 'closed');
        }
      } catch (e) { }

      // Hide popup and FAB temporarily
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
      reopen.style.display = 'none';
    },
    
    restoreProgressBarPopup: function () {
      const popup = document.getElementById('progress-bar-popup');
      const reopen = document.getElementById('pb-reopen');
      const OPEN_STATE_KEY = 'pbOpenState';

      if (!popup || !reopen) return;

      let state = null;
      try {
        state = sessionStorage.getItem(OPEN_STATE_KEY);
      } catch (e) { }

      if (state === 'open') {
        popup.classList.add('is-open');
        popup.setAttribute('aria-hidden', 'false');
        reopen.style.display = 'none';
      } else if (state === 'closed') {
        popup.classList.remove('is-open');
        popup.setAttribute('aria-hidden', 'true');
        reopen.style.display = 'flex';
        reopen.style.opacity = '1';
      }
    },

    /**
     * Safely updates or appends a width parameter to an image URL.
     * Strips any existing width parameters to prevent duplicates while 
     * preserving other query strings (like Shopify's ?v= versioning).
     * @param {string} url - The original image URL.
     * @param {string|number} size - The desired width in pixels.
     * @returns {string} The formatted URL with the new width parameter.
     */
    formatUrl: function (url, size) {
      if (!url) return '';
        let newUrl = url.replace(/&width=\d+/g, '').replace(/\?width=\d+&/g, '?').replace(/\?width=\d+$/, '');
        return newUrl + (newUrl.includes('?') ? '&' : '?') + 'width=' + size;
    },

    /**
     * Formats a number with comma thousand separators and fixed decimal places.
     * @param {number} amount - The number to format.
     * @param {number} decimals - Decimal places (default 2).
     * @returns {string} e.g. 1234.5 → "1,234.50"
     */
    fmtPrice: function(amount, decimals = 2) {
      return parseFloat(amount).toFixed(decimals).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
};

const AsiaCurrencyFormatter = {
  CURRENCY_CODES: ['BND', 'HKD', 'IDR', 'JPY', 'KRW', 'MYR', 'PHP', 'SGD', 'THB', 'TWD', 'VND'],

  PRICE_SELECTORS: [
    '.price',
    '.compare-price',
    '.prices',
    '.price-text',
    '.cart--price',
    '.subscribe-price',
    '.subscribe-price-reg',
    '.lp-price',
    '.header-price',
    '.ymal-content p',
    '.free-ship-msg-remaining',
    '.sticky-atc-submit span'
  ].join(', '),

  init: function() {
    if (!window.location.hostname.includes('asia.selkirk.com')) return;

    this.CURRENCY_REGEX = new RegExp(' (' + this.CURRENCY_CODES.join('|') + ')\\b', 'g');

    document.addEventListener('DOMContentLoaded', () => {
      document.querySelectorAll(this.PRICE_SELECTORS).forEach(el => this.stripEl(el));
    });

    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType !== Node.ELEMENT_NODE) return;
          if (node.matches && node.matches(this.PRICE_SELECTORS)) this.stripEl(node);
          node.querySelectorAll(this.PRICE_SELECTORS).forEach(el => this.stripEl(el));
        });
      });
    });

    observer.observe(document.body || document.documentElement, { childList: true, subtree: true });
  },

  stripEl: function(el) {
    el.childNodes.forEach(node => {
      if (node.nodeType === Node.TEXT_NODE) {
        node.nodeValue = node.nodeValue.replace(this.CURRENCY_REGEX, '');
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        this.stripEl(node);
      }
    });
  }
};

AsiaCurrencyFormatter.init();